// import { iNoBounce } from './modules/iNoBounce';
import { horizon } from "./modules/horizon";
import { book } from "./modules/book";
import { randomImg } from "./modules/randomImg";
// import { mv } from './modules/mv';
// import { recommended } from './modules/recommended';
imagesLoaded(document.querySelector("#container"), function(instance) {
  // iNoBounce();
  // import { base_scroll } from './modules/base_scroll';
  // base_scroll();
  // import { header } from './modules/header';
  // header();

  // if($('.recommendedPage').length){
  // 	recommended();
  // }
  // if($('.topPage').length){
  // 	mv();
  // }

  horizon();
  book();
  randomImg();

  $(function() {
    $(".pageTop a").click(function() {
      // $('main').animate({scrollLeft:999999},0);
      document.querySelector(".globalFooter").classList.remove("active");
    });
    $('.innerLink[href^="/"]').click(function() {
      smooth(this);
      return false;
    });

    // $('.pageTop a').click(function () {
    // 	animateoffset(0);
    // 	return false;
    // });

    // // smoothScroll
    function smooth(target) {
      var href = $(target).attr("href"); //引数targetが持つhref値を取得
      //var offset = $('#pageHeader').height();
      var h = href.substring(9);
      console.log(h);
      // var offset = 0;//何px下に下げるかの数値
      // console.log($(h).offset().left);
      // var hx = window.pageXOffset + document.querySelector(h).getBoundingClientRect().left;
      // console.log(hx);
      var left = $(h).position().left - window.innerWidth + $(h).innerWidth();
      // var left = $(h).position().left;
      console.log(left);
      animateoffset(left); //実際にスクロールさせる関数animateoffsetを実行
    }
    function animateoffset(left) {
      $("main").animate({ scrollLeft: left }, 1000); //引数topの値までスクロールさせる
    }

    // window.onload = () => {
    // }
    const ua = navigator.userAgent;
    if (ua.indexOf("Trident") !== -1) {
      let idname = location.hash;
      console.log(idname);
      var left =
        $(idname).position().left - window.innerWidth + $(idname).innerWidth();
      $("main").scrollLeft(left);
    }

    //==================================================================================================================
    //▼ Header event
    //------------------------------------------------------------------------------------------------------------------
    //================================================
    //▼ nav open
    //------------------------------------------------
    //▼ header Element get
    const pageHeader = document.querySelector("#pageHeader");
    const navOpen = document.querySelector("#navOpen");
    // const navDown = document.querySelectorAll('.navDown');
    const headerLink = document.querySelectorAll(".headerLink");
    // const navDowninner = $('.global--nav_list_cmn_list');
    // const navCmn = document.querySelectorAll('.global--nav_list');

    const windowH = window.innerHeight;

    let winW = window.innerWidth;
    let winH = window.innerHeight;
    if (winW < winH) {
      //▼ nav buttton clickEvent classAdd
      // $('.globalNav_lists').hide();
      navOpen.addEventListener("click", function() {
        pageHeader.classList.toggle("open");
        // $('.globalNav_lists').classList.toggle('open');
        // $('.globalNav_lists').slideToggle(300);
      });
      for (var i = 0; i < headerLink.length; i++) {
        headerLink[i].addEventListener("click", function() {
          pageHeader.classList.remove("open");
        });
      }

      // window.onload = () =>{
      // 	var $currentpath = window.location.pathname.replace('//', '').replace(/./, '').replace(/_/, '-'); // 表示中のページのファイル名を取得する
      // 	if ( !$currentpath ) {$currentpath = "homepage";} // トップページ（ファイル名が存在しない場合）に登録する任意のファイル名
      // 	if ( window.name.indexOf( '#' + $currentpath )!=-1 ) { //ウィンドウ名に現在のファイル名が含まれるかチェック
      // 	} else {
      // 			window.name = window.name + '#' + $currentpath; // ウィンドウ名の末尾にファイル名を追加する、#はエスケープ処理
      // 			var inst = $('[data-remodal-id=first]').remodal();
      // 			inst.open();
      // 		}
      // }
    }

    // window.onload = () => {
    // 	$('body').addClass('active');
    // }
    //
    // const event = window.cordova ? 'deviceready' : 'DOMContentLoaded';
    // document.addEventListener(event, function() {
    // 	$('body').addClass('active')
    // }, false);

    // const mayoBtn = document.querySelector('.j-btn_mayo');
    // const mayoimg = document.querySelector('.p-manager_linkArea_img_hover');
    // mayoBtn.addEventListener('mouseenter', function(){
    // 	mayoimg.classList.add('active');
    // });
    // mayoBtn.addEventListener('mouseleave', function(){
    // 	mayoimg.classList.remove('active');
    // });
  });
});
